import React, { useState, useEffect, useContext } from 'react'
import { apiPut } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import { useForm } from 'react-hook-form'
import useToastContext from 'hooks/useToastContext'
import ErrorMessage from 'components/ErrorMessage'
import { useTranslation } from 'react-i18next'
import OInputField from 'components/reusable/OInputField'
import { preventMaxInput } from 'utils/validations'
import formValidation from '../../utils/formValidation'
import OImage from 'components/reusable/OImage'
import { isEmpty } from 'lodash'
import noImageFound from '../../assets/images/No-image-found.jpg'
import { useNavigate, useLocation } from 'react-router-dom'
import AuthContext from 'context/AuthContext'
import helpers from 'utils/helpers'

const BannerEdit = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const notification = useToastContext()
  const { updatePageName } = useContext(AuthContext)
  const [isLoading, setIsLoading] = useState(false)
  const location = useLocation()
  const item = location?.state
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: 'onChange',
    shouldFocusError: true,
    defaultValues: {
      title: item?.title
    }
  })
  const [passportPic, setPassportPic] = useState(item?.bannerImage)
  const [imageError, setImageError] = useState('')

  const validateFiles = passportPics => {
    let picError = ''
    const supportedTypes = ['image/jpeg', 'image/jpg', 'image/png']

    if (!isEmpty(supportedTypes.includes(passportPics.type))) {
      picError = 'Only jpeg, jpg and png are supported.'
    }

    return helpers.checkPicError(picError, setImageError)
  }
  const handleFileChangeLogo = e => {
    const bannerImage = e?.target?.files[0]
    const fileSize = (e.target.files[0]?.size / (1024 * 1024)).toFixed(2)
    const isValidImage = validateFiles(bannerImage)
    if (isValidImage) {
      if (fileSize > 3) {
        notification.error('Please select image below 3Mb.')
        return false
      }
      setPassportPic(bannerImage)
      return true
    } else {
      setPassportPic(null)
    }
  }
  const validateFunc = () => {
    helpers.ternaryCondition(
      passportPic,
      setImageError(false),
      setImageError(true)
    )
    return true
  }

  const onSubmit = async data => {
    try {
      const isValid = validateFunc()
      if (!isValid) {
        return
      }
      setIsLoading(true)
      const formData = new FormData()
      formData.append('title', data.title?.trim())

      helpers.ifParameter(passportPic, formData, 'bannerImage', passportPic)
      const result = await apiPut(
        apiPath?.updateBanner + '/' + item?._id,
        formData
      )
      function successCallback () {
        navigate('/banner-management')
        notification.success(result?.data?.message)
      }
      function errorCallback () {
        notification.error(result?.data?.message)
      }

      helpers.handleResult(
        result?.data?.success,
        successCallback,
        errorCallback
      )
    } catch (error) {
      console.log('error in get all company list==>>>>', error)
      notification.error(error.message)
    }
    setIsLoading(false)
  }
  useEffect(() => {
    updatePageName(t('EDIT_BANNER'))
  }, [])

  const renderButtonOrSpinner = () => {
    return helpers.ternaryCondition(isLoading, renderSpinner(), renderButton())
  }

  const renderSpinner = () => (
    <div className='spinner-container bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 ease-linear transition-all duration-150'>
      <div className='loading-spinner'></div>
    </div>
  )

  const renderButton = () => (
    <button
      type='submit'
      className={`bg-LightBlue cursor-pointer text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 ease-linear transition-all duration-150`}
      onClick={handleSubmit(onSubmit)}
    >
      {t('O_SAVE')}
    </button>
  )

  return (
    <>
      <div>
        <div className='bg-[#F9F9F9]'>
          <div className='px-3 py-4'>
            <div className='bg-white border border-[#E9EDF9] rounded-lg'>
              <div className='relative p-6 flex-auto'>
                <div className='grid'>
                  <div className='px-2'>
                    <OInputField
                      wrapperClassName='relative z-0 w-full group'
                      name='title'
                      inputLabel={
                        <>
                          {t('TITLE')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='text'
                      autoFocus
                      maxLength={100}
                      onInput={e => preventMaxInput(e, 100)}
                      register={register('title', formValidation['title'])}
                      errors={errors}
                    />
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0   w-full group'>
                      <div className='block py-3 h-14 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'>
                        <input
                          type='file'
                          name='bannerImage'
                          className='form-control'
                          accept='image/png,image/jpeg,image/jpg'
                          onChange={handleFileChangeLogo}
                        />
                      </div>
                      <label
                        htmlFor='floating_file'
                        className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-1 left-0 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                      >
                        {t('IMAGE')}
                        <span className='text-red-500'>*</span>
                      </label>
                      <div className='flex items-center bg-white w-full h-[648px]'>
                        <OImage
                          src={
                            passportPic == item?.bannerImage
                              ? item?.bannerImage
                              : URL.createObjectURL(passportPic)
                          }
                          fallbackUrl={noImageFound}
                          alt='card'
                          className={'w-full h-full mt-5 object-cover'}
                        />
                      </div>
                      {helpers.andCondition(
                        imageError,
                        <ErrorMessage message='Please upload the image.' />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                <button
                  className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
                  type='button'
                  onClick={() => navigate('/banner-management')}
                >
                  {t('O_BACK')}
                </button>
                {renderButtonOrSpinner()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default BannerEdit
